// @generated by protoc-gen-connect-query v1.4.1 with parameter "target=ts"
// @generated from file no/jotta/openapi/customer/customer.v2.proto (package no.jotta.openapi.customer.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { MethodKind } from "@bufbuild/protobuf";
import { AcceptFamilyInviteRequest, AcceptFamilyInviteResponse, ApproveLoginRequest, ApproveLoginResponse, CreateIdentityLinkRequest, CreateIdentityLinkResponse, DowngradeAccountRequest, DowngradeAccountResponse, GetCustomerRequest, GetCustomerResponse, GetFamilyRequest, GetFamilyResponse, PatchCustomerRequest, PatchCustomerResponse, RevokeFamilyInviteRequest, RevokeFamilyInviteResponse, SendFamilyInviteRequest, SendFamilyInviteResponse, SetOnboardingTaskRequest, SetOnboardingTaskResponse, TerminateAccountRequest, TerminateAccountResponse } from "./customer.v2_pb.js";
import { ConfirmTFARequest, ConfirmTFAResponse, DisableTFARequest, DisableTFAResponse, GenerateLoginTokenRequest, GenerateLoginTokenResponse, InitializeTFARequest, InitializeTFAResponse } from "../auth/v2/auth.v2_pb.js";
import { PingRequest, PingResponse } from "../ping_pb.js";
/**
 * @generated from rpc no.jotta.openapi.customer.v2.CustomerService.GetCustomer
 */
export const getCustomer = {
    localName: "getCustomer",
    name: "GetCustomer",
    kind: MethodKind.Unary,
    I: GetCustomerRequest,
    O: GetCustomerResponse,
    service: {
        typeName: "no.jotta.openapi.customer.v2.CustomerService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.customer.v2.CustomerService.PatchCustomer
 */
export const patchCustomer = {
    localName: "patchCustomer",
    name: "PatchCustomer",
    kind: MethodKind.Unary,
    I: PatchCustomerRequest,
    O: PatchCustomerResponse,
    service: {
        typeName: "no.jotta.openapi.customer.v2.CustomerService"
    }
};
/**
 * Get more information about the family in a family subscription.
 * Returns Status Not Found for accounts without family.
 *
 * @generated from rpc no.jotta.openapi.customer.v2.CustomerService.GetFamily
 */
export const getFamily = {
    localName: "getFamily",
    name: "GetFamily",
    kind: MethodKind.Unary,
    I: GetFamilyRequest,
    O: GetFamilyResponse,
    service: {
        typeName: "no.jotta.openapi.customer.v2.CustomerService"
    }
};
/**
 * Send invitation to join a Family Subscription.
 * Only valid for accounts with a family subscription.
 *
 * @generated from rpc no.jotta.openapi.customer.v2.CustomerService.SendFamilyInvite
 */
export const sendFamilyInvite = {
    localName: "sendFamilyInvite",
    name: "SendFamilyInvite",
    kind: MethodKind.Unary,
    I: SendFamilyInviteRequest,
    O: SendFamilyInviteResponse,
    service: {
        typeName: "no.jotta.openapi.customer.v2.CustomerService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.customer.v2.CustomerService.TerminateAccount
 */
export const terminateAccount = {
    localName: "terminateAccount",
    name: "TerminateAccount",
    kind: MethodKind.Unary,
    I: TerminateAccountRequest,
    O: TerminateAccountResponse,
    service: {
        typeName: "no.jotta.openapi.customer.v2.CustomerService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.customer.v2.CustomerService.DowngradeAccount
 */
export const downgradeAccount = {
    localName: "downgradeAccount",
    name: "DowngradeAccount",
    kind: MethodKind.Unary,
    I: DowngradeAccountRequest,
    O: DowngradeAccountResponse,
    service: {
        typeName: "no.jotta.openapi.customer.v2.CustomerService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.customer.v2.CustomerService.GenerateLoginToken
 */
export const generateLoginToken = {
    localName: "generateLoginToken",
    name: "GenerateLoginToken",
    kind: MethodKind.Unary,
    I: GenerateLoginTokenRequest,
    O: GenerateLoginTokenResponse,
    service: {
        typeName: "no.jotta.openapi.customer.v2.CustomerService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.customer.v2.CustomerService.ApproveLogin
 */
export const approveLogin = {
    localName: "approveLogin",
    name: "ApproveLogin",
    kind: MethodKind.Unary,
    I: ApproveLoginRequest,
    O: ApproveLoginResponse,
    service: {
        typeName: "no.jotta.openapi.customer.v2.CustomerService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.customer.v2.CustomerService.InitializeTFA
 */
export const initializeTFA = {
    localName: "initializeTFA",
    name: "InitializeTFA",
    kind: MethodKind.Unary,
    I: InitializeTFARequest,
    O: InitializeTFAResponse,
    service: {
        typeName: "no.jotta.openapi.customer.v2.CustomerService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.customer.v2.CustomerService.ConfirmTFA
 */
export const confirmTFA = {
    localName: "confirmTFA",
    name: "ConfirmTFA",
    kind: MethodKind.Unary,
    I: ConfirmTFARequest,
    O: ConfirmTFAResponse,
    service: {
        typeName: "no.jotta.openapi.customer.v2.CustomerService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.customer.v2.CustomerService.DisableTFA
 */
export const disableTFA = {
    localName: "disableTFA",
    name: "DisableTFA",
    kind: MethodKind.Unary,
    I: DisableTFARequest,
    O: DisableTFAResponse,
    service: {
        typeName: "no.jotta.openapi.customer.v2.CustomerService"
    }
};
/**
 * Revokes an invite code. The invite must have been sent by the current user.
 *
 * @generated from rpc no.jotta.openapi.customer.v2.CustomerService.RevokeFamilyInvite
 */
export const revokeFamilyInvite = {
    localName: "revokeFamilyInvite",
    name: "RevokeFamilyInvite",
    kind: MethodKind.Unary,
    I: RevokeFamilyInviteRequest,
    O: RevokeFamilyInviteResponse,
    service: {
        typeName: "no.jotta.openapi.customer.v2.CustomerService"
    }
};
/**
 * Accept an invite code as the current user.
 *
 * @generated from rpc no.jotta.openapi.customer.v2.CustomerService.AcceptFamilyInvite
 */
export const acceptFamilyInvite = {
    localName: "acceptFamilyInvite",
    name: "AcceptFamilyInvite",
    kind: MethodKind.Unary,
    I: AcceptFamilyInviteRequest,
    O: AcceptFamilyInviteResponse,
    service: {
        typeName: "no.jotta.openapi.customer.v2.CustomerService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.customer.v2.CustomerService.SetOnboardingTask
 */
export const setOnboardingTask = {
    localName: "setOnboardingTask",
    name: "SetOnboardingTask",
    kind: MethodKind.Unary,
    I: SetOnboardingTaskRequest,
    O: SetOnboardingTaskResponse,
    service: {
        typeName: "no.jotta.openapi.customer.v2.CustomerService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.customer.v2.CustomerService.CreateIdentityLink
 */
export const createIdentityLink = {
    localName: "createIdentityLink",
    name: "CreateIdentityLink",
    kind: MethodKind.Unary,
    I: CreateIdentityLinkRequest,
    O: CreateIdentityLinkResponse,
    service: {
        typeName: "no.jotta.openapi.customer.v2.CustomerService"
    }
};
/**
 * Safe noop for testing purposes
 *
 * @generated from rpc no.jotta.openapi.customer.v2.CustomerService.Ping
 */
export const ping = {
    localName: "ping",
    name: "Ping",
    kind: MethodKind.Unary,
    I: PingRequest,
    O: PingResponse,
    service: {
        typeName: "no.jotta.openapi.customer.v2.CustomerService"
    }
};
